import {Checkbox, Col, Row} from "antd"
import styles from "./WorkDayItem.module.css"
import {BaseTimePicker} from "components/DateTimePicker"
import {useModel} from "hooks"
import {Auth} from "types/auth"
import {getDisabledEndHours, getDisabledEndMinutes} from "helpers/calendar"
import cx from "classnames"
import {useEffect, useMemo, useState} from "react"
import moment, {Moment} from "moment"
import {Icon} from "components"
import {WorkDay} from "types/work-schedule"

type Props = {
    item: WorkDay
    errors?: any
    onChange: (_workday: WorkDay) => void
}

export function WorkDayItem(props: Props) {
    const {item, errors, onChange} = props
    const model = useModel()
    const [workDay, setWorkDay] = useState<WorkDay>(item)

    useEffect(() => {
        setWorkDay(item)
    }, [item])

    const onChangeWorkDay = (field: keyof WorkDay, value: any) => {
        const _workDay = {
            ...workDay,
            [field]: value
        }
        if (field === "startTime" && value) {
            const isSameDate = moment(value).add(9, "hour").startOf("date").isSame(moment(value).startOf("date"))
            _workDay.endTime = isSameDate ? moment(value).add(9, "hour") : moment(value).endOf("date")
        }
        setWorkDay(_workDay)
        onChange(_workDay)
    }

    const checkboxDisabled = useMemo(() => !workDay.enabled || workDay.allDay, [workDay.enabled, workDay.allDay])

    return (
        <div className={styles.workDayContainer}>
            <Row gutter={[8, 8]} className={styles.container}>
                <Col span={6}>
                    <Checkbox
                        checked={workDay.enabled}
                        onChange={(event) => onChangeWorkDay("enabled", event.target.checked)}
                        className={cx(styles.label, {[styles.labelDisabled]: !workDay.enabled})}>
                        {workDay.name}
                    </Checkbox>
                </Col>
                <Col span={18} className={styles.allDayContainer}>
                    <Checkbox
                        checked={workDay.allDay}
                        onChange={(e) => onChangeWorkDay("allDay", e.target.checked)}
                        disabled={!workDay.enabled}
                        className={styles.allDay}>
                        All day
                    </Checkbox>
                </Col>
            </Row>
            <div className={styles.timeRange}>
                <BaseTimePicker
                    value={workDay.startTime || undefined}
                    onChange={(newValue) => onChangeWorkDay("startTime", newValue)}
                    placeholder="From"
                    format={model.user.timeFormat === Auth.TimeFormat.Time_12 ? "hh:mm A" : "HH:mm"}
                    error={errors?.includes("startTime")}
                    disabled={checkboxDisabled}
                    suffixIcon={
                        <div className={cx(styles.calendarIconWrap, {[styles.disabledCalenderIcon]: checkboxDisabled})}>
                            <Icon icon="TIME_CLOCK_OUTLINE" color="#fff" />
                        </div>
                    }
                    className={styles.timePicker}
                    size="small"
                />
                <BaseTimePicker
                    value={workDay.endTime || undefined}
                    onChange={(newValue) => onChangeWorkDay("endTime", newValue)}
                    disabledHours={() => getDisabledEndHours(workDay.startTime)}
                    disabledMinutes={() => getDisabledEndMinutes(workDay.startTime, workDay.endTime)}
                    placeholder="To"
                    format={model.user.timeFormat === Auth.TimeFormat.Time_12 ? "hh:mm A" : "HH:mm"}
                    error={errors?.includes("endTime")}
                    disabled={checkboxDisabled}
                    suffixIcon={
                        <div className={cx(styles.calendarIconWrap, {[styles.disabledCalenderIcon]: checkboxDisabled})}>
                            <Icon icon="TIME_CLOCK_OUTLINE" color="#fff" />
                        </div>
                    }
                    className={styles.timePicker}
                    size="small"
                />
            </div>
        </div>
    )
}
